<template>
    <div class="">
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <!-- Heading -->
                    <div class="w-lg-65 text-center mx-lg-auto mb-4">
                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Header" tag-name="h2" :init="EditorConfig" />
                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Leadin" :init="EditorConfig" />
                    </div>
                    <!-- End Heading -->

                    <div class="w-lg-65 mx-lg-auto mb-0">
                        <div class="row row-cols-2 row-cols-sm-3 justify-content-center">
                            <div class="col" v-if="FieldInspectionConfig.reportHDPhotos">
                                <!-- Icon Block -->
                                <div class="text-center">
                                    <div class="mb-3">
                                        <i class="bi-camera fs-1" :style="{'color': BlockProps.IconColor}"></i>
                                    </div>
                                    <h5 :style="{'color': BlockProps.TextColor}">HD Photography</h5>
                                </div>
                                <!-- End Icon Block -->
                            </div>
                            <!-- End Col -->

                            <div class="col" v-if="FieldInspectionConfig.reportHDVideo">
                                <!-- Icon Block -->
                                <div class="text-center">
                                    <div class="mb-3">
                                        <i class="bi-camera-video fs-1" :style="{'color': BlockProps.IconColor}"></i>
                                    </div>
                                    <h5 :style="{'color': BlockProps.TextColor}">HD Video</h5>
                                </div>
                                <!-- End Icon Block -->
                            </div>
                            <!-- End Col -->

                            <div class="col" v-if="FieldInspectionConfig.reportLiveStream">
                                <!-- Icon Block -->
                                <div class="text-center">
                                    <div class="mb-3">
                                        <i class="bi-webcam fs-1" :style="{'color': BlockProps.IconColor}"></i>
                                    </div>
                                    <h5 :style="{'color': BlockProps.TextColor}">Live Streaming</h5>
                                </div>
                                <!-- End Icon Block -->
                            </div>
                            <div class="col">
                                <!-- Icon Block -->
                                <div class="text-center">
                                    <div class="mb-3">
                                        <i class="bi-list-check fs-1" :style="{'color': BlockProps.IconColor}"></i>
                                    </div>
                                    <h5 :style="{'color': BlockProps.TextColor}">Custom Checklist</h5>
                                </div>
                                <!-- End Icon Block -->
                            </div>
                            <div class="col">
                                <!-- Icon Block -->
                                <div class="text-center">
                                    <div class="mb-3">
                                        <i class="bi-cloud-download fs-1" :style="{'color': BlockProps.IconColor}"></i>
                                    </div>
                                    <h5 :style="{'color': BlockProps.TextColor}">Digital Report Download</h5>
                                </div>
                                <!-- End Icon Block -->
                            </div>
                            <!-- End Col -->
                        </div>
                        <!-- End Row -->
                    </div>

                    <!-- End Row -->
                </div>
            </div>

        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertycoloreditor :propertyname="'TextColor'" :blockprops="BlockProps" :prompt="'Text Color'"></propertycoloreditor>
                        <propertycoloreditor :propertyname="'IconColor'" :blockprops="BlockProps" :prompt="'Icon Color'"></propertycoloreditor>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'InspectionFeatureCloud',
        mixins: [ContentBlockBase],
        props: [],
        components: {

        },
        computed:
        {           
            FieldInspectionConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.fieldinspectionconfig) {
                    return this.fieldinspectionconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigFieldInspection) {
                    return this.Store.TenantConfig.serviceConfigFieldInspection;
                }
            }
        },
        data() {
            return {  
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#FieldInspectionSettings'
            };
        },
        watch: {
            
        },
        methods:
        {           
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            
        },
        beforeUnmount()
        {
            
        },
        mounted() {
            nextTick().then(() => {
         
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>

